<main class="flex-1 max-w-[1500px] mx-auto w-full px-7 lg:px-12 py-9">

    <!-- Success Message -->
    <div *ngIf="successMessage"
        class="mb-4 p-[18px] rounded-lg bg-green-50 border border-green-200 text-green-700 flex items-center gap-2 text-sm">

        <span class="material-symbols-outlined text-[20px]">check_circle</span>
        {{ successMessage }}

    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage"
        class="mb-4 p-[18px] rounded-lg bg-red-50 border border-red-200 text-red-700 flex items-center gap-2 text-sm">

        <span class="material-symbols-outlined text-[20px]">error</span>
        {{ errorMessage }}

    </div>

    <!-- TITLE -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 mb-5">

        <div>
            <h2 class="text-[22px] font-bold text-slate-900 tracking-tight">
                Quotation Management
            </h2>

            <p class="text-sm text-slate-500 mt-1">
                Configure website locales and translations.
            </p>
        </div>

        <button (click)="addNew()"
            class="flex items-center gap-2 bg-primary hover:bg-primary/90 text-white px-3.5 py-2 rounded-md font-semibold shadow transition-all text-sm">

            <span class="material-symbols-outlined text-[20px]">add</span>
            <span>Add</span>

        </button>

    </div>

    <div class="flex border-b border-slate-200 mb-4 gap-6">

        <!-- Dynamic Languages -->
        <button *ngFor="let lang of languages" (click)="setTab(lang.code)"
            class="pb-3 px-6 text-base font-semibold border-b-2 transition-all flex items-center gap-2"
            [class.text-primary]="activeTab === lang.code" [class.border-primary]="activeTab === lang.code">

            <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-slate-200">

            {{ lang.name }} ({{ getLanguageCount(lang.code) }})

        </button>

    </div>

    <div class="mb-4 max-w-[420px]">
        <input type="text" [(ngModel)]="searchText" (ngModelChange)="filterQuotation(activeTab)"
            placeholder="Search quotations"
            class="w-full border border-slate-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
    </div>

    <!-- TABLE -->
    <div class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">

        <div class="overflow-x-auto">

            <table class="w-full text-left border-collapse">

                <thead>
                    <tr class="bg-slate-50 border-b border-slate-200">

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">
                            Header
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase">
                            Body
                        </th>

                        <th>
                            Status
                        </th>

                        <th class="px-3.5 py-2.5 text-xs font-bold text-slate-500 uppercase text-right"
                            style="width:150px">
                            Actions
                        </th>

                    </tr>
                </thead>

                <tbody class="divide-y divide-slate-100">

                    <tr *ngFor="let obj of pagedQuotation" class="hover:bg-slate-50 transition-colors">

                        <!-- Destination -->
                        <td class="px-3.5 py-2.5 text-slate-600 col-width-250">
                            <span class="px-2 py-1 text-xs rounded bg-slate-100 text-slate-600">
                                {{ obj.header }}
                            </span>
                        </td>

                        <!-- Link -->
                        <td class="px-3.5 py-2.5">
                            <span class="px-2 py-1 text-xs rounded bg-slate-100 text-slate-600">
                                {{ obj.body }}
                            </span>
                        </td>


                        <!-- Enable -->
                        <td class="px-3.5 py-2.5 font-semibold text-slate-100 col-width">
                            <div class="flex cursor-pointer">
                                <span class="relative inline-block w-10 h-5 rounded-full transition-colors duration-300"
                                    [ngClass]="obj.isPublish === true ? 'bg-green-500' : 'bg-gray-300'">
                                    <span
                                        class="absolute left-0 top-0 w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-300"
                                        [ngStyle]="{'transform': obj.isPublish === true ? 'translateX(100%)' : 'translateX(0)'}">
                                    </span>
                                </span>

                                <span class="px-2 py-1 text-xs text-slate-600">
                                    {{ obj.isPublish === true ? 'Publish' : 'Unpublish' }}
                                </span>
                            </div>
                        </td>

                        <!-- Actions -->
                        <td class="px-3.5 py-2.5 text-right col-width">
                            <div class="flex justify-end gap-2">
                                <button class="p-1.5 text-slate-400 hover:text-primary"
                                    (click)="viewData(obj.quoteId,'Edit')">
                                    <span class="material-symbols-outlined text-[20px]">edit</span>
                                </button>

                                <button class="p-1.5 text-slate-400 hover:text-red-500"
                                    (click)="viewData(obj.quoteId,'Delete')">
                                    <span class="material-symbols-outlined text-[20px]">delete</span>
                                </button>
                            </div>
                        </td>

                    </tr>

                </tbody>

                <tfoot>
                    <tr>
                        <td colspan="4">
                            <div class="flex justify-center mt-6 mb-6 gap-2">
                                <button *ngFor="let page of [].constructor(totalPages()); let i = index"
                                    (click)="changePage(i + 1)"
                                    [ngClass]="currentPage === (i+1) ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'"
                                    class="px-4 py-2 min-w-[40px] rounded hover:bg-blue-400 hover:text-white transition-colors text-sm">
                                    {{ i + 1 }}
                                </button>
                            </div>
                        </td>
                    </tr>
                </tfoot>

            </table>

        </div>

    </div>

</main>

<!-- MODAL -->
<div *ngIf="isModalOpen" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

    <div class="bg-white w-[725px] rounded-xl shadow-xl">

        <!-- Header -->
        <div class="px-5 py-3.5 border-b border-slate-200 flex justify-between items-center bg-slate-50">

            <div>
                <h3 class="text-[18px] font-bold text-slate-900 flex items-center gap-2">
                    <span class="material-symbols-outlined text-[20px]">admin_panel_settings</span>
                    Add New Quotation
                </h3>

                <p class="text-sm text-slate-500 mt-0.5">
                    Define and configure a new quotation for the portal.
                </p>
            </div>

            <button class="text-slate-400 hover:text-slate-600" (click)="closeModal()">
                <span class="material-symbols-outlined text-[22px]">close</span>
            </button>

        </div>

        <!-- Body -->
        <div class="p-5 space-y-6 bg-white rounded-lg shadow-sm">

            <div class="p-6 space-y-5">

                <!-- Image Upload -->
                <div class="flex items-center gap-4">
                    <label class="w-[150px] text-sm font-semibold text-gray-700">
                        Image
                    </label>
                    <input type="file" (change)="onFileSelected($event)" name="imageUrl"
                           class="flex-1 border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                           accept="image/*" />
                </div>

                <!-- Is Publish -->
                <div class="flex items-center gap-4">
                    <label class="w-[150px] text-sm font-semibold text-gray-700">
                        Publish
                    </label>
                    <input type="checkbox" [(ngModel)]="isPublish" name="isPublish"
                           class="h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" />
                </div>

                <!-- Language Tabs -->
                <div class="flex border-b border-gray-200 gap-6 mt-6">
                    <button *ngFor="let lang of languages" (click)="setTabPopup(lang.languageId)"
                            class="pb-3 px-6 text-sm font-semibold border-b-2 flex items-center gap-2 transition-all"
                            [class.text-primary]="activeTabPopup === lang.languageId"
                            [class.border-primary]="activeTabPopup === lang.languageId">
                        <img [src]="lang.icon" class="w-6 h-6 rounded-full object-cover border border-gray-200" />
                        {{ lang.name }}
                    </button>
                </div>

                <!-- Form Fields -->
                <form enctype="multipart/form-data" class="space-y-4 mt-4">

                    <!-- Khmer Name -->
                    <div *ngIf="activeTabPopup === 1">
                        <label class="block mb-1 text-sm font-semibold text-gray-700">
                            Header
                        </label>
                        <textarea [(ngModel)]="header_kh" name="header_kh" required
                            placeholder="Enter header"
                            rows="3"
                            class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"></textarea>

                        <label class="block mb-1 text-sm font-semibold text-gray-700">
                            Body
                        </label>
                        <textarea [(ngModel)]="body_kh" name="body_kh" required
                            placeholder="Enter body"
                            rows="6"
                            class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"></textarea>
                        
                    </div>

                    <!-- English Name -->
                    <div *ngIf="activeTabPopup === 2">
                        <label class="block mb-1 text-sm font-semibold text-gray-700">
                            Header
                        </label>
                        <textarea [(ngModel)]="header_en" name="header_en" required
                            placeholder="Enter header"
                            rows="3"
                            class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"></textarea>
                    
                        <label class="block mb-1 text-sm font-semibold text-gray-700">
                            Body
                        </label>
                        <textarea [(ngModel)]="body_en" name="body_en" required
                            placeholder="Enter body"
                            rows="6"
                            class="w-full border border-gray-300 rounded-md px-3.5 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"></textarea>

                    </div>

                </form>

            </div>

        </div>

        <!-- Footer -->
        <div class="px-5 py-3.5 bg-slate-50 flex justify-end gap-3 border-t border-slate-200">

            <button (click)="save()" *ngIf="isEnableSave" class="btn-primary">
                <span class="material-symbols-outlined text-[18px]">check_circle</span>
                Create
            </button>

            <button (click)="update()" *ngIf="isEnableUpdate" class="btn-warning">
                <span class="material-symbols-outlined text-[18px]">warning</span>
                Update
            </button>

            <button (click)="delete()" *ngIf="isEnableDelete" class="btn-danger">
                <span class="material-symbols-outlined text-[18px]">delete</span>
                Delete
            </button>

        </div>

    </div>
</div>
